<template>
  <div>
    <div class="md-table-cell-container">
      <router-link
        :to="currentRoute + '/' + entityId + '/detail'"
        v-if="canViewDetail"
      >
        <md-button class="md-just-icon md-success md-simple table-action">
          <md-tooltip md-direction="top">{{ $t("common.view") }} </md-tooltip>
          <md-icon>{{
            $can(Class.actions.edit, Class.subject) ? "edit" : "visibility"
          }}</md-icon>
        </md-button>
      </router-link>

      <md-button
        v-if="$can(Class.actions.copy, Class.subject)"
        class="md-just-icon md-warning md-simple table-action"
        @click.native="triggerConfirmCopy"
      >
        <md-tooltip md-direction="top">Copy</md-tooltip>
        <md-icon>content_copy</md-icon>
      </md-button>

      <md-button
        class="md-just-icon md-info md-simple table-action"
        @click.native="triggerConfirmConclude"
        v-if="
          item.status === status.ON_GOING &&
            $can(Class.actions.conclude, Class.subject)
        "
      >
        <md-tooltip md-direction="top">{{ $t("common.conclude") }}</md-tooltip>
        <i class="far fa-check-circle"></i>
      </md-button>

      <md-button
        v-if="$can(Class.actions.delete, Class.subject)"
        class="md-just-icon md-danger md-simple table-action"
        @click.native="triggerConfirmDelete"
      >
        <md-tooltip md-direction="top">{{ $t("common.delete") }} </md-tooltip>
        <md-icon>close</md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
import { Class } from "@/constants/Permissions";

export default {
  props: ["item"],
  data() {
    return {
      status: {
        ON_GOING: "On-going",
        CONCLUDED: "Concluded"
      },
      Class
    };
  },
  inject: ["confirmConclude", "confirmDelete", "confirmCopy"],
  methods: {
    triggerConfirmConclude() {
      this.confirmConclude(this.item);
    },
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    },
    triggerConfirmCopy() {
      this.confirmCopy(this.item);
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    },

    entityId() {
      return this.item.id || this.item._id;
    },

    canViewDetail() {
      return (
        this.$can(Class.actions.edit, Class.subject) ||
        this.$can(Class.actions.view, Class.subject)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
